"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _composeInjections = _interopRequireDefault(require("../../injections/composeInjections"));

var _baseThunkAction = _interopRequireDefault(require("../../injections/baseThunkAction"));

function createThunkAction(type, target, serviceCall) {
  var payload = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function () {};
  console.warn('redux-recompose: createThunkAction is deprecated. Use fetch middleware instead.');
  return (0, _composeInjections["default"])((0, _baseThunkAction["default"])({
    type: type,
    target: target,
    serviceCall: serviceCall,
    payload: payload
  }));
}

var _default = createThunkAction;
exports["default"] = _default;